import {Vue} from '~/addiesaas'
import * as types from '../mutation-types/timer'

// set this true to namespace all getters, mutations, actions etc.
export const namespaced = true
export const namespace = 'Timer'
const rootNamespace = 'RacewayBooking'
export const absoluteNamespace = [rootNamespace, namespace].join('/')

// state
const state = {
  countdowns: {}
}

// mutations
const mutations = {
  [types.SET_TIMER](state, {id, endValue, startValue}) {
    id = id || 'global'
    Vue.set(state.countdowns, id, {endValue, startValue})
  },
  [types.UNSET_TIMER](state, {id}) {
    id = id || 'global'
    Vue.delete(state.countdowns, id)
  }
}

const actions = {
  setCountdownTimer({commit}, payload) {
    commit(types.SET_TIMER, payload)
  },
  unsetCountdownTimer({commit}, payload) {
    commit(types.UNSET_TIMER, payload)
  }
}

// getters
const getters = {
  timerCountdowns: state => state.countdowns
}

const timer = {namespaced, namespace, absoluteNamespace, state, mutations, actions, getters}
export default timer
